import React from 'react';
import { Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import RateInputs from './RateInputs';
import css from '../../../../styles.module.css';
import { useSegment } from '../../../../../../../components/tracking/trackingProvider';

export default function RatesManager({ selected_rates, bookingSelectionAuto, form, rates, onClear = () => {}, remaining_quota, onChangeSelectedRate = () => {} }) {
    const { t } = useTranslation();
    const { track } = useSegment();

    if (!selected_rates.length > 0) return null;

    return (
        <div className={css['rates-manager-container']}>
            <div className={css['rates-manager-delete-all']}>
                <span
                    onClick={() => {
                        onClear(selected_rates);
                        track('ACTION > DELETE ALL', { 'Page Title': 'ADD ATTENDEES' });
                    }}
                >
                    <Icon name="trash" size="regular" />
                    {t('attendees.addAttendees.selectHierarchy.delete')}
                </span>
            </div>
            {selected_rates.map(selected_rate => (
                <RateInputs
                    key={selected_rate.id}
                    form={form}
                    remaining_session_quota={remaining_quota}
                    rates={rates}
                    bookingSelectionAuto={bookingSelectionAuto}
                    unselectRate={toClear => {
                        onClear(toClear);
                        track('ACTION > DELETE RATE', { 'Page Title': 'ADD ATTENDEES' });
                    }}
                    selected_rate={selected_rate}
                    onChangeSelectedRate={onChangeSelectedRate}
                />
            ))}
        </div>
    );
}
